/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BooleanResponse } from '../../models/boolean-response';

export interface DeleteProfileFile$Params {

/**
 * Id of profile to which uploaded file belongs.
 */
  id: number;

/**
 * Id of profile file to delete.
 */
  profileFileId: number;
}

export function deleteProfileFile(http: HttpClient, rootUrl: string, params: DeleteProfileFile$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteProfileFile.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('profileFileId', params.profileFileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BooleanResponse>;
    })
  );
}

deleteProfileFile.PATH = '/rest/profile/{id}/file/{profileFileId}';
